import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Spinner,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import CommonDataTable from "./Table/CommonDataTable";

const TransactionsModal = ({
  isOpen,
  toggle,
  title = "Payment History",
  data = [],
  tableColumnNames = [],
  loading = false,
  permission = {},
}) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  // Filter state
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  // today's date in YYYY-MM-DD for max on date input
  const today = new Date().toISOString().split("T")[0];

  // If there's a header-specific loading state elsewhere, it isn't
  // provided to this component. Fall back to false so expressions
  // like (loading || headerLoading) behave correctly.
  const headerLoading = false;

  const actionConfig = {
    showCheckboxColumn: false,
    action: false,
  };

  // Derive filtered data from props.data using searchTerm, date range and status
  const filteredData = (data || []).filter((item) => {
    // Search: stringify values
    if (searchTerm) {
      const hay = Object.values(item || {}).join(" ").toLowerCase();
      if (!hay.includes(searchTerm.toLowerCase())) return false;
    }

    // Status filter: match StatusID (number) or Status (string)
    if (status) {
      // StatusID: 1=Pending, 2=Failed, 3=Completed/Paid
      const statusId = String(item.StatusID ?? "");
      if (statusId !== status) return false;
    }

    // Date filter: CreatedDate
    if (fromDate || toDate) {
      const dateStr = item.CreatedDate ?? "";
      if (!dateStr) return false;
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return false;
      if (fromDate && d < new Date(fromDate)) return false;
      if (toDate && d > new Date(toDate)) return false;
    }

    return true;
  });

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      toggle={toggle}
      centered
      backdrop="static"
    >
      <ModalHeader toggle={toggle}>
        {title}
      </ModalHeader>
      <ModalBody>
        <Container fluid className="p-0">
          {/* Loading State */}
          {loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner
                style={{ height: "3rem", width: "3rem" }}
                className="me-2"
              >
                {t("Loading")}
              </Spinner>
            </div>
          ) : (
            /* Data Table */
            <div className="table-responsive">
              <Card>
                    <CardHeader>
                        <Row className="g-4 ">
                            <Col className="col-sm-auto">
                            <div className="d-flex gap-2">
                              {/* --- Added: value and onChange wired to state --- */}
                              <Input type="date" name="dateFrom" value={fromDate} onChange={(e) => setFromDate(e.target.value)} max={today} />
                              <Input type="date" name="dateTo" value={toDate} onChange={(e) => setToDate(e.target.value)} max={today} />
                              <Input type="select" name="status" value={status} onChange={(e) => setStatus(e.target.value)}>
                                <option value="">{t("SelectStatus")}</option>
                                <option value="3">{t("Paid")}</option>
                                <option value="1">{t("Pending")}</option>
                                <option value="2">{t("Failed")}</option>
                              </Input>
                            </div>

                            </Col>
                            <Col className="col-sm">
                            <div className="d-flex justify-content-sm-end">
                                <div className="search-box ms-2 me-2">
                                <Input
                                    type="text"
                                    className="form-control search"
                                    placeholder={t("Search here")}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <i className="ri-search-line search-icon"></i>
                                </div>
                            </div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {loading ? (
                        <div className="d-flex justify-content-center align-items-center py-5">
                            <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                            Loading...
                            </Spinner>
                        </div>
                        ) : (
                        <div className="listjs-table" id="customerList">
                          <CommonDataTable
                            data={filteredData}
                            tableColumnNames={tableColumnNames}
                            searchTerm={searchTerm}
                            actionConfig={actionConfig}
                            permission={permission}
                          />
                        </div>
                        )}
                    </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default TransactionsModal;
